import styles from './GrupoEncabezado.module.css';

// Franja naranja que abre y cierra un grupo (una propiedad, una torre) con su
// nombre y unas cifras de resumen. La comparten Propietarios, Torres y Unidades,
// que antes tenían cada una su copia con medidas ligeramente distintas.
//   icono: nombre del icono de Font Awesome sin el prefijo (p. ej. 'building')
//   cifras: [{ etiqueta, valor, mono? }]  (mono: letra de ancho fijo, para el coeficiente)
export default function GrupoEncabezado({ icono, titulo, subtitulo, cifras, abierto, onAlternar }) {
  return (
    <div onClick={onAlternar} className={styles.encabezado}>
      <div className={styles.nombre}>
        <i className={`fas fa-${icono} ${styles.icono}`} />
        <span className={styles.titulo}>{titulo}</span>
        {subtitulo && <span className={styles.subtitulo}>{subtitulo}</span>}
      </div>
      <div className={styles.cifras}>
        {cifras.map((c) => (
          <div key={c.etiqueta} className={styles.cifra}>
            <div className={styles.cifraEtiqueta}>{c.etiqueta}</div>
            <div className={c.mono ? `${styles.cifraValor} ${styles.cifraValorMono}` : styles.cifraValor}>{c.valor}</div>
          </div>
        ))}
        <i className={`fas fa-chevron-${abierto ? 'up' : 'down'} ${styles.flecha}`} />
      </div>
    </div>
  );
}
